// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- External UI Libraries
import { Drawer } from "antd";
// --- Hooks & Actions
import { useJobsActions } from "tap/store/licensingJobs/useJobs.js";
import Button from "@dtci/spellbook/Button";
import { LicensingUploadTasksForm } from "./tasks-form";

/**
 * Side panel listing validation errors from a licensing job file upload.
 * @param {Object} props
 * @param {Function} props.onOpenUploadDialog - Opens the upload dialog again
 */
export function UploadTasksDrawer({ onOpenUploadDialog }) {
  const { isUploadTasksDrawerOpen } = useSelector((state) => state.licensingJobs);
  const { updateJobs } = useJobsActions();

  const handleClose = () => {
    updateJobs({
      isUploadTasksDrawerOpen: false,
      licensingJobUploadTasks: [],
    });
  };

  return (
    <Drawer
      className="create-drawer"
      title="Upload Tasks"
      width={750}
      placement="right"
      open={isUploadTasksDrawerOpen}
      onClose={handleClose}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div
          className="button-row"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            iconType="fa-solid fa-xmark"
            labelText="close"
            styleType="link"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            iconType="fa-solid fa-upload"
            labelText="Upload"
            styleType="link"
            onClick={() => {
              onOpenUploadDialog();
              handleClose();
            }}
          >
            Upload
          </Button>
        </div>
      }
    >
      <LicensingUploadTasksForm />
    </Drawer>
  );
}
